import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerSW } from "@/lib/swRegister";
import { startAutoSync } from "@/lib/offlineSync";

// ---------------------------------------------------------------------------
// "ResizeObserver loop completed with undelivered notifications" gürültüsünü
// KAYNAĞINDA kır: ResizeObserver constructor'ını monkey-patch et. Callback'i
// requestAnimationFrame ile sarmalayarak observation loop'un patlamasını
// engelle (Chrome + Radix UI Popover/Dialog bileşenlerinde bilinen problem).
// ---------------------------------------------------------------------------
const patchResizeObserver = () => {
  if (typeof window === "undefined" || !window.ResizeObserver) return;
  const OldRO = window.ResizeObserver;
  window.ResizeObserver = class PatchedResizeObserver extends OldRO {
    constructor(callback) {
      let scheduled = false;
      let latestArgs;
      const wrapped = (...args) => {
        latestArgs = args;
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(() => {
          scheduled = false;
          try { callback(...latestArgs); } catch { /* noop */ }
        });
      };
      super(wrapped);
    }
  };
};
patchResizeObserver();

// Ek güvenlik: CRA / webpack-dev-server overlay'inin bu hatayı yakalamasını
// da engelle — global error / unhandledrejection dinleyicileri.
const RESIZE_OBSERVER_ERR = "ResizeObserver loop";
const suppressResizeObserverErrors = () => {
  window.addEventListener("error", (e) => {
    if (e?.message && e.message.includes(RESIZE_OBSERVER_ERR)) {
      e.stopImmediatePropagation();
      e.preventDefault?.();
    }
  }, true); // capture: true → önce yakala
  window.addEventListener("unhandledrejection", (e) => {
    const msg = e?.reason?.message || "";
    if (typeof msg === "string" && msg.includes(RESIZE_OBSERVER_ERR)) {
      e.preventDefault();
      e.stopImmediatePropagation?.();
    }
  }, true);
};
suppressResizeObserverErrors();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

registerSW();
startAutoSync();
